import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  imports: [CommonModule, TranslateModule, RouterModule]
})
export class ReportsComponent implements OnInit {
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {

  }
}
